import {
  BaseQueryFn,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query';
import { getApiUrl } from '@Utils/getApiUrl';
import { defineAuthHeaders } from '@Utils/api/defineAuthHeaders';
import { extractAuthToken } from '@Utils/api/extractAuthToken';

const baseUrl = getApiUrl();

export const customBaseQuery: BaseQueryFn = async (args, api, extraOptions) => {
  const baseResult = await fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      return defineAuthHeaders({ headers, token: extractAuthToken(getState) });
    },
    responseHandler: async (response) => {
      const isExcel = response.headers
        .get('content-type')
        ?.includes('application/vnd.ms-excel');

      if (isExcel) {
        return response.blob();
      }

      const isMaintenance = response.headers.get('X-Maintenance-Mode');

      if (isMaintenance) {
        const timeMaintenance = response.headers.get('X-Maintenance-Until');
        sessionStorage.setItem('X-Maintenance-Until', timeMaintenance || '');

        window.location.href = '/maintenance';
        return undefined;
      }

      if (response.headers.get('content-type')?.includes('text/plain')) {
        const text = await response.text();
        return text;
      }

      const text = await response.text();

      return text ? JSON.parse(text) : response;
    },
  })(args, api, extraOptions);

  if (baseResult.error) {
    const { error } = baseResult;

    if ('status' in error) {
      const extendedError = error as FetchBaseQueryError & {
        originalStatus: number;
      };

      if (extendedError.originalStatus === 403) {
        window.location.href = '/403';
      }

      if (extendedError.originalStatus === 404) {
        error.data = 'Request Error 404. Resource not found.';
      }

      if (extendedError.originalStatus === 500) {
        error.data = 'Request Error 500. Internal Server Error.';
      }
    }
  }

  return {
    ...baseResult,
  };
};
